import { render, staticRenderFns } from "./paymentMethods.vue?vue&type=template&id=4765390a&scoped=true&"
import script from "./paymentMethods.vue?vue&type=script&lang=js&"
export * from "./paymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./paymentMethods.vue?vue&type=style&index=0&id=4765390a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765390a",
  null
  
)

export default component.exports